import React from 'react';
import Layout from '../../features/Layout';
import LendingTerms from '../../components/LendingTerms';

const LendingTermsPage = ({ isProd }) => {
  return (
    <Layout
      title="Khatabook - Our Apps"
      description="Digital India's Digital Khata! Download Khatabook now & take charge of all your transactions, use Khatabook and grow your business!"
      isProd={isProd}
    >
      <LendingTerms />
    </Layout>
  );
};

export default LendingTermsPage;
